import {Component, Inject, OnInit} from '@angular/core';
import {LocalizableError} from 'src/app/models/LocalizableError';
import {IncludeTime, LabelsService} from 'src/app/services/labels.service';
import {environment} from '../../../environments/environment';
import {Event} from '../../models/Event';
import {EVENT_SERVICE, LABELS_SERVICE} from '../../providers/service.providers';
import {EventService} from '../../services/event.service';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'app-preview',
    templateUrl: './preview.component.html',
    styleUrls: ['./preview.component.scss']
})
export class PreviewComponent implements OnInit {
    public allEvents: Event[];
    public isLoading: boolean;
    public error?: LocalizableError;
    public internalEventPage: string;
    public IncludeTime = IncludeTime;

    constructor(@Inject(EVENT_SERVICE) private eventService: EventService, @Inject(LABELS_SERVICE) public labelsService: LabelsService) {
    }

    ngOnInit(): void {
        if (environment.usePreview) {
          this.internalEventPage = environment.internalEventPage;
        }
        this.loadPublishedEvents();
    }

    private loadPublishedEvents() {
        this.isLoading = true;
        this.eventService.getPublishedEvents().subscribe(
            (events) => {
              events = events.filter((event) => {
                const today = new Date();
                return (new Date(event.endDate) >= today);
              });
              events.sort((a, b) => (Number(new Date(a.startDate.toString()))) - (Number(new Date(b.startDate.toString()))));
              this.allEvents = events.slice(0, 3);
              this.isLoading = false;
            },
            (error: LocalizableError) => this.handleErrorResponse(error)
        );
    }

    private handleErrorResponse(error: LocalizableError) {
        this.error = error;
        this.isLoading = false;
    }

    getAreaLabel(event: Event): string {
        const date = this.labelsService.getDateString(event);
        const building = event.building ? `at ${event.building.name}` : '';
        return `${event.eventName} on ${date} ${building}`;
    }

    public hasInternalLink() {
      return this.internalEventPage;
    }

  public hasExternalLink(event: Event) {
    return event.publicEventUrl && !event.publicEventUrl.includes('.microsoftcrmportals.com');
  }
}
